export const ATOM_KEY = {
    STATUS_MODE: "STATUS_MODE",
    CHECK_IN: "CHECK_IN",
    CHECK_OUT: "CHECK_OUT",
    CHECK_COUNT: "CHECK_COUNT",
    CHECK_LIMIT: "CHECK_LIMIT",
    SELECTED_RESERVE_ROOM: "SELECTED_RESERVE_ROOM",
    SELECTED_ADULT_PERSON: "SELECTED_ADULT_PERSON",
    SELECTED_CHILD_PERSON: "SELECTED_CHILD_PERSON",
    SELECTED_INFANT_PERSON: "SELECTED_INFANT_PERSON",
    SELECTED_PAYMENT_ROOM: "SELECTED_PAYMENT_ROOM",
    SELECTED_PAID_ROOM: "SELECTED_PAID_ROOM",
    PENSION_NAME: "PENSION_NAME",
    PAID_METHOD: "PAID_METHOD",
    COMPLETED_ROOM: "COMPLETED_ROOM",
    BOOKING_CHECK: "BOOKING_CHECK",
    GROUP_NAME: "GROUP_NAME",
};
